import React from "react";

/**
 * BrandHeart — the QHearts brand mark (outlined heart with Q/H cutout).
 * Drop-in replacement for a lucide icon in decorative positions.
 *
 * Sizing comes from the Tailwind className (e.g. "w-6 h-6"); the image
 * will fill the box while keeping its aspect ratio.
 */
export default function BrandHeart({ className = "w-5 h-5", alt = "" }) {
  return (
    <img
      src="/assets/brand-heart.png"
      alt={alt}
      aria-hidden={alt ? undefined : "true"}
      draggable="false"
      className={`${className} object-contain select-none pointer-events-none`}
    />
  );
}
